"use client"

import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { useEffect, useState } from "react"

export function Toaster() {
  const { toasts } = useToast()
  const [userRole, setUserRole] = useState<string>('')

  // Get user role from sessionStorage
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const userString = sessionStorage.getItem('user')
      if (userString) {
        try {
          const user = JSON.parse(userString)
          setUserRole(user?.role || '')
        } catch (e) {
          console.error('Failed to parse user:', e)
        }
      }
    }
  }, [])

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle role={userRole}>{title}</ToastTitle>}
              {description && (
                <ToastDescription role={userRole}>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
